import { Flex, Typography } from '@aloft/toolkit-sui';

export const Update = ({
  title,
  description,
  children,
}: React.PropsWithChildren<{ title: string; description?: string }>) => (
  <Flex flexDirection="column" gap={2}>
    <Typography variant="h2">{title}</Typography>
    {description && <Typography variant="body1">{description}</Typography>}
    {children}
  </Flex>
);
